import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import Navigation from './Navigation';

const LeadHistory = () => {
    const { t } = useTranslation();
    return (
        <section className="pt-4 pb-24">
            <h2 className="mb-2 text-base font-medium text-midnight">{t('HISTORY.HEADER')}</h2>
            <div className="max-w-5xl">
                <Navigation />
                <Outlet />
            </div>
        </section>
    );
};

export default LeadHistory;
